import { render, staticRenderFns } from "./client-edit-form.html?vue&type=template&id=54fbf161&scoped=true&"
import script from "./client-edit-form.ts?vue&type=script&lang=js&"
export * from "./client-edit-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fbf161",
  null
  
)

export default component.exports